import React, { useContext, useEffect, useState } from 'react';

import { Typography, Checkbox, FormControlLabel, Box, useTheme } from '@mui/material';

import CustomImageComponent from '@/components/shared/custom/custom-image';
import { Context } from '@/context';
import { FANTASY } from '@/helpers/biwenger-helper';
import CustomTabs from '@/components/master-player-modal/tabs/custom-tabs';

const estadisticas = [
    { title: 'Minutos disputados', key: 'mp' },
    { title: 'Goles', key: 'g' },
    { title: 'Asistencias de gol', key: 'a' },
    { title: 'Asistencias sin gol', key: 'asg' },
    { title: 'Balones al área', key: 'laa' },
    { title: 'Penaltis provocados', key: 'pg' },
    { title: 'Penaltis parados', key: 'ps' },
    { title: 'Paradas', key: 's' },
    { title: 'Despejes', key: 'de' },
    { title: 'Penaltis fallados', key: 'pf' },
    { title: 'Goles en propia puerta', key: 'og' },
    { title: 'Goles en contra', key: 'gc' },
    { title: 'Tarjetas amarillas', key: 'yc' },
    { title: 'Segundas amarillas', key: 'sy' },
    { title: 'Tarjetas rojas', key: 'rc' },
    { title: 'Tiros a puerta', key: 'tap' },
    { title: 'Regates', key: 'reg' },
    { title: 'Balones recuperados', key: 'rec' },
    { title: 'Posesiones perdidas', key: 'pos' },
    { title: 'Penaltis cometidos', key: 'penc' },
];

const biwengerEstadisticas = [
    { title: 'Entró', key: 'in' },
    { title: 'Salió', key: 'out' },
    { title: 'Goles', key: 'goals' },
    { title: 'Asistencias', key: 'assistances' },
    { title: 'Tarjetas amarilla', key: 'yellowCard' },
    { title: 'Segundas amarillas', key: 'secondYellowCard' },
    { title: 'Tarjetas Roja', key: 'redCard' },
];

const estadisticaRelevo = {
    title: 'Puntos relevo',
    key: 'marp',
};

const PlayersDaysPoints = ({ player }) => {
    const theme = useTheme();

    const weeks = player?.weeks?.sort((a, b) => b - a);
    const [value, setValue] = useState(weeks?.[0] ?? 0);
    const [stats, setStats] = useState([]);
    const [showOnlyWithValues, setShowOnlyWithValues] = useState(true); // Estado para el checkbox
    const { state } = useContext(Context);
    const { preferences } = state;

    const getColor = (puntos) => {
        if (puntos > 0) {
            return theme.mercado.up;
        } else if (puntos < 0) {
            return theme.mercado.down;
        } else {
            return theme.palette.text.primary;
        }
    };

    const getCantidad = (estadistica, position) => {
        const weekStats = player?.estadisticas?.playerStats?.find((x) => x.w === value);
        const cantidad = weekStats?.s?.[estadistica.key]?.[position];

        return cantidad ?? '-';
    };

    const getTotalPoints = () => {
        const weekStats = player?.estadisticas?.playerStats?.find((x) => x.w === value);
        return weekStats?.totalPoints ?? '-';
    };

    const handleClick = (week) => {
        setValue(week);
    };

    useEffect(() => {
        if (preferences.fantasy === FANTASY.BIWENGER) {
            setStats(biwengerEstadisticas);
        } else {
            setStats(estadisticas);
        }
    }, [preferences.fantasy]);

    // Función para verificar si la estadística tiene valores distintos de 0
    const hasValues = (estadistica) => {
        return getCantidad(estadistica, 0) !== 0 || getCantidad(estadistica, 1) !== 0;
    };

    return (
        <Box
            className="jugadores-component"
            style={{ padding: '10px', boxShadow: '0 2px 8px rgba(0,0,0,.1)' }}
            mb={2}
            width={'100%'}
        >
            <Box className="journeys-container">
                <CustomTabs player={player} handleClick={handleClick} selected={value} weeks={weeks} />

                <Box className="estadisticas-jornada">
                    <Box style={{ paddingLeft: '8px', display: 'flex', alignItems: 'center' }}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={showOnlyWithValues}
                                    onChange={() => setShowOnlyWithValues(!showOnlyWithValues)}
                                />
                            }
                            label="Mostrar solo estadísticas con valores"
                        />
                    </Box>
                    <Box className="estadisticas-jornada__title">
                        <Typography style={{ fontWeight: 600 }}>
                            {value > 0 ? `Jornada ${value}` : '-'}
                        </Typography>
                    </Box>

                    <Box className="estadisticas-jornada__header">
                        <Box className="estadisticas-jornada__column-left">
                            <Typography variant="h6">Cantidad</Typography>
                        </Box>
                        <Box className="estadisticas-jornada__column-center">
                            <Typography variant="h6">Estadísticas</Typography>
                        </Box>
                        <Box className="estadisticas-jornada__column-right">
                            <Typography variant="h6">Puntos</Typography>
                        </Box>
                    </Box>

                    {stats
                        ?.filter((estadistica) => (showOnlyWithValues ? hasValues(estadistica) : true)) // Filtra si está marcado
                        .map((estadistica, index) => (
                            <Box
                                key={index}
                                className="estadisticas-jornada__line"
                                style={{
                                    backgroundColor:
                                        getCantidad(estadistica, 0) > 0 || getCantidad(estadistica, 1) > 0
                                            ? theme.palette.background.darkCard
                                            : theme.palette.background.default,
                                }}
                            >
                                <Box className="estadisticas-jornada__column-left">
                                    <Typography variant="h6">{getCantidad(estadistica, 0) ?? '-'}</Typography>
                                </Box>
                                <Box className="estadisticas-jornada__column-center">
                                    <Typography variant="h6" style={{ fontWeight: 400 }}>
                                        {estadistica.title}
                                    </Typography>
                                </Box>
                                <Box className="estadisticas-jornada__column-right">
                                    <Typography
                                        variant="h6"
                                        style={{
                                            color: getColor(getCantidad(estadistica, 1)),
                                            fontWeight: 400,
                                        }}
                                    >
                                        {getCantidad(estadistica, 1) ?? '-'}
                                    </Typography>
                                </Box>
                            </Box>
                        ))}

                    {preferences.fantasy !== FANTASY.BIWENGER && (
                        <>
                            <Box
                                className="estadisticas-jornada__line"
                                style={{
                                    backgroundColor:
                                        getCantidad(estadisticaRelevo, 1) > 0
                                            ? theme.palette.background.darkCard
                                            : theme.palette.background.default,
                                }}
                            >
                                <Box className="estadisticas-jornada__column-left">
                                    <Typography variant="h6">
                                        <CustomImageComponent
                                            src={`${process.env.NEXT_PUBLIC_IMAGES}/competitions/relevo.png?width=100&height=40`}
                                            alt="dazn"
                                            width={100}
                                            height={40}
                                        />
                                    </Typography>
                                </Box>
                                <Box className="estadisticas-jornada__column-center">
                                    <Typography variant="h6">Puntos Dazn</Typography>
                                </Box>
                                <Box className="estadisticas-jornada__column-right">
                                    <Typography
                                        variant="h6"
                                        style={{ color: getColor(getCantidad(estadisticaRelevo, 1)) }}
                                    >
                                        {getCantidad(estadisticaRelevo, 1)}
                                    </Typography>
                                </Box>
                            </Box>

                            <Box
                                className="estadisticas-jornada__header"
                                style={{
                                    backgroundColor: theme.palette.background.darkCard,
                                }}
                            >
                                <Box className="estadisticas-jornada__column-left">
                                    <Typography variant="h6">
                                        <CustomImageComponent
                                            src={`${process.env.NEXT_PUBLIC_IMAGES}/competitions/la-liga.png?width=20&height=20`}
                                            alt="la-liga"
                                            width={20}
                                            height={20}
                                        />
                                    </Typography>
                                </Box>
                                <Box className="estadisticas-jornada__column-center">
                                    <Typography variant="h6">Total</Typography>
                                </Box>
                                <Box className="estadisticas-jornada__column-right">
                                    <Typography variant="h6">{getTotalPoints()}</Typography>
                                </Box>
                            </Box>
                        </>
                    )}
                </Box>
            </Box>
        </Box>
    );
};

export default PlayersDaysPoints;
